import { useContext, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {useLoginUserMutation} from '../services/appApi'
import { AppContext } from "../context/appContext";

import "./Login.css";
import { useSelector } from "react-redux";


const Login = () => {
    const navigate = useNavigate()
    const user = useSelector((state) => state.user)
    const { socket } = useContext(AppContext)
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const { email, password } = formData;
    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };
    //login a user
    const [loginUser, {isLoading, error}] = useLoginUserMutation()
    const loginNewUser = (e) => {
        e.preventDefault();
        loginUser({ email, password }).then(({data}) => {
            if(data) {
                //socket work
                socket.emit('new-user')
                //navigate to the chat
                navigate('/chat')
            }
        })
    };
    return (
        <Row>
            <Col
                md={6}
                className="d-flex flex-direction-colum align-items-center justify-content-center"
            >
                <div>
                    <Form onSubmit={loginNewUser} >
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                                name="email"
                                onChange={onChange}
                                value={email}
                                type="email"
                                placeholder="Enter email"
                            />
                            <Form.Text className="text-muted">
                                We'll never share your email with anyone else.
                            </Form.Text>
                        </Form.Group>

                        <Form.Group
                            className="mb-3"
                            controlId="formBasicPassword"
                        >
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                name="password"
                                value={password}
                                onChange={onChange}
                                type="password"
                                placeholder="Password"
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            Login
                        </Button>
                        <div>
                            No account? <Link to="/register">Register</Link>
                        </div>
                    </Form>
                </div>
            </Col>
            <Col className="login_bg"></Col>
        </Row>
    );
};

export default Login;
